import { DatePipe } from '@angular/common';
import { Component, input, output, signal } from '@angular/core';
import {
  GcButtonComponent,
  GcIconComponent,
  GcLoadingSpinnerComponent,
  GcTagComponent,
  GcTextComponent,
  IpoTranslatePipe,
} from '@ip-only/front-end-library';
import { InstallationReportSelfInspectionItem } from '../../model/installation-reporting-mdu-section.types';
import { ItemAnswer } from '../../state/installation-reporting-mdu-section-state.types';
import { FileMetaV2Response } from '../../model/installation-reporting-mdu-bff.entities';
import { SharedModule } from '../../../../../shared/shared.module';

@Component({
  selector: 'app-self-inspection-item',
  imports: [
    GcTextComponent,
    GcButtonComponent,
    GcTagComponent,
    GcIconComponent,
    GcLoadingSpinnerComponent,
    IpoTranslatePipe,
    DatePipe,
    SharedModule,
  ],
  templateUrl: './self-inspection-item.component.html',
  styleUrl: './self-inspection-item.component.scss',
})
export class SelfInspectionItemComponent {
  item = input.required<InstallationReportSelfInspectionItem>();
  answer = input.required<ItemAnswer>();
  completed = input(false);
  loading = input(false);

  markDone = output<void>();
  markNotApplicable = output<string>();
  uploadFiles = output<File[]>();
  undo = output<void>();
  viewAttachments = output<{
    itemId: string;
    attachments: FileMetaV2Response[];
  }>();
  showNotApplicableForm = signal(false);

  completionMethodKey(): string {
    return this.answer().isNotCompletable
      ? 'installationReportV2.selfInspection.na'
      : 'installationReportV2.selfInspection.done';
  }

  onFileSelected(event: Event) {
    const fileInput = event.target as HTMLInputElement;
    const files = fileInput.files ? Array.from(fileInput.files) : [];
    fileInput.value = '';
    if (files.length) {
      this.uploadFiles.emit(files);
    }
  }

  openNotApplicableForm() {
    this.showNotApplicableForm.set(true);
  }

  closeNotApplicableForm() {
    this.showNotApplicableForm.set(false);
  }

  onMarkNotApplicable(comment: string) {
    this.markNotApplicable.emit(comment);
    this.closeNotApplicableForm();
  }
}
